// Copyright (c) 2021 WiseTime. All rights reserved.

import {
  PostTimeRequest,
  PostTimeRequestSchema,
  TimeGroup,
} from "../../generated/wisetime/user/timeline/v4/timeline_pb"
import { SiteRef } from "../../generated/wisetime/type/site_ref_pb"
import { hoursToSecondsRounded, secondsToHoursRounded } from "./timeGroups"
import { create } from "@bufbuild/protobuf"

export const roundedTotalDuration = (seconds: number, roundingPreferenceSeconds: number): number =>
  hoursToSecondsRounded(secondsToHoursRounded(seconds, roundingPreferenceSeconds).toString())

export const buildPostTimeRequest = (
  timeGroup: TimeGroup,
  currentSiteRef: SiteRef,
  roundingPreferenceSeconds: number,
): PostTimeRequest => create(PostTimeRequestSchema, {
  site: {
    id: currentSiteRef.id,
    displayName: currentSiteRef.displayName,
  },
  timeGroups: [{
    timeGroupId: timeGroup.id,
    tags: timeGroup.tags
      .filter(tag => tag.siteId === currentSiteRef.id)
      .map(tag => ({ id: tag.id, siteId: tag.siteId, name: tag.name })),
    selectedTimesheetFieldOptions: timeGroup.selectedTimesheetFieldOptions
      .filter(o => o.siteId === currentSiteRef.id)
      .map(o => ({
        siteId: o.siteId,
        timesheetFieldId: o.timesheetFieldId,
        timesheetFieldOptionId: o.timesheetFieldOptionId,
      })),
    totalDuration: {
      seconds: BigInt(timeGroup.totalDuration?.seconds ?? 0),
      nanos: timeGroup.totalDuration?.nanos ?? 0,
    },
    roundedTotalDuration: {
      seconds: BigInt(roundedTotalDuration(Number(timeGroup.totalDuration?.seconds ?? 0), roundingPreferenceSeconds)),
      nanos: 0,
    },
  }],
})
